<template>
  <div style="height:100%">
    <!-- Task dashboard skeleton loader -->
    <b-row
      v-if="isLoadingList"
      class="position-relative task-dashboard-row mt-5 mx-0"
    >
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pl-0">
        <b-card class="mt-5 px-2 py-2 task-cards-wrapper" no-body>
          <div>
            <Container>
              <b-card
                v-for="index in 3"
                :key="generateId(index)"
                no-body
                class="px-4 py-3 mb-3 position-relative task-cards-container"
              >
                <div class="d-flex align-items-center position-relative">
                  <b-skeleton width="9rem"></b-skeleton>
                </div>
                <b-skeleton class="mt-4" width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%" class="mb-4"></b-skeleton>
                <b-row class="d-flex mx-0 category-buttons-wrapper">
                  <b-skeleton
                    v-for="index in 2"
                    :key="index"
                    class="mr-2 mb-3 btn-pill"
                    width="5rem"
                    height="2rem"
                  >
                  </b-skeleton>
                </b-row>
                <div class="d-flex align-items-center position-relative mb-2">
                  <b-skeleton type="avatar" size="3.5rem"></b-skeleton>
                  <div class="skeleton-icons-group d-flex position-absolute">
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                  </div>
                </div>
              </b-card>
            </Container>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pl-0">
        <b-card class="mt-5 px-2 py-2 task-cards-wrapper" no-body>
          <div>
            <Container>
              <b-card
                v-for="index in 3"
                :key="generateId(index)"
                no-body
                class="px-4 py-3 mb-3 position-relative task-cards-container"
              >
                <div class="d-flex align-items-center position-relative">
                  <b-skeleton width="9rem"></b-skeleton>
                </div>
                <b-skeleton class="mt-4" width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%" class="mb-4"></b-skeleton>
                <b-row class="d-flex mx-0 category-buttons-wrapper">
                  <b-skeleton
                    v-for="index in 2"
                    :key="index"
                    class="mr-2 mb-3 btn-pill"
                    width="5rem"
                    height="2rem"
                  >
                  </b-skeleton>
                </b-row>
                <div class="d-flex align-items-center position-relative mb-2">
                  <b-skeleton type="avatar" size="3.5rem"></b-skeleton>
                  <div class="skeleton-icons-group d-flex position-absolute">
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                  </div>
                </div>
              </b-card>
            </Container>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pl-0">
        <b-card class="mt-5 px-2 py-2 task-cards-wrapper" no-body>
          <div>
            <Container>
              <b-card
                v-for="index in 3"
                :key="generateId(index)"
                no-body
                class="px-4 py-3 mb-3 position-relative task-cards-container"
              >
                <div class="d-flex align-items-center position-relative">
                  <b-skeleton width="9rem"></b-skeleton>
                </div>
                <b-skeleton class="mt-4" width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%" class="mb-4"></b-skeleton>
                <b-row class="d-flex mx-0 category-buttons-wrapper">
                  <b-skeleton
                    v-for="index in 3"
                    :key="generateId(index)"
                    class="mr-2 mb-3 btn-pill"
                    width="5rem"
                    height="2rem"
                  >
                  </b-skeleton>
                </b-row>
                <div class="d-flex align-items-center position-relative mb-2">
                  <b-skeleton type="avatar" size="3.5rem"></b-skeleton>
                  <div class="skeleton-icons-group d-flex position-absolute">
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                  </div>
                </div>
              </b-card>
            </Container>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pl-0">
        <b-card class="mt-5 px-2 py-2 task-cards-wrapper" no-body>
          <div>
            <Container>
              <b-card
                v-for="index in 3"
                :key="generateId(index)"
                no-body
                class="px-4 py-3 mb-3 position-relative task-cards-container"
              >
                <div class="d-flex align-items-center position-relative">
                  <b-skeleton width="9rem"></b-skeleton>
                </div>
                <b-skeleton class="mt-4" width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%" class="mb-4"></b-skeleton>
                <b-row class="d-flex mx-0 category-buttons-wrapper">
                  <b-skeleton
                    v-for="index in 2"
                    :key="index"
                    class="mr-2 mb-3 btn-pill"
                    width="5rem"
                    height="2rem"
                  >
                  </b-skeleton>
                </b-row>
                <div class="d-flex align-items-center position-relative mb-2">
                  <b-skeleton type="avatar" size="3.5rem"></b-skeleton>
                  <div class="skeleton-icons-group d-flex position-absolute">
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                    <b-skeleton
                      width="2.2rem"
                      height="1.5rem"
                      class="mr-3"
                    ></b-skeleton>
                  </div>
                </div>
              </b-card>
            </Container>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <!-- End skeleton loader -->

    <!-- Start task dashboard cards -->
    <b-row
      v-if="statusLoaded"
      class="position-relative task-dashboard-row mt-4"
      ref="taskDashboardRow"
    >
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pr-0 cards-container">
        <b-card
          class=" px-2 py-2"
          :class="{
            'task-cards-wrapper': dailyTasks.length,
            'empty-task-cards-wrapper': !dailyTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_new_task.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listOneTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              v-if="!searchMode"
              :cardCount="dailyTasks.length"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[0]"
              :board="BOARDS.EA"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              non-drag-area-selector=".drag-disabled"
              :get-child-payload="getChildPayload1"
              group-name="1"
              class="container daily-container"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('dailyTasks', $event)"
              @drag-start="dragListener"
              @drag-end="dragListener"
            >
              <Draggable v-for="item in dailyTasks" :key="item.id">
                <TaskCards
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                  :priority="item.priority === 'high' ? true : false"
                  :isLoadingList="isLoadingList"
                  :class="cardClass"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :cardData="item"
                  :list="dailyTasks"
                  :statusTitle="listOneTitle"
                  :trackerID="item.lastTracker.id"
                  :shouldPatch="shouldPatch"
                  v-on:updateQueue="reloadQueues"
                  @card-moved="onCardMoved"
                  :status="statusIdOne"
                  :profileId="profileId"
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                @infinite="infiniteHandlerDaily"
                :identifier="dailyInfiniteId"
                force-use-infinite-wrapper=".daily-container"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[todoTasks.length === 0 ? 'add-another-task-btn' : null]"
          >
            <h6
              v-if="role === 'assistant' && !searchMode"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdOne, true)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pr-0 cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': todoTasks.length,
            'empty-task-cards-wrapper': !todoTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_today.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listTwoTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              v-if="!searchMode"
              :cardCount="todoTasks.length"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[1]"
              :board="BOARDS.EA"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :get-child-payload="getChildPayload2"
              group-name="1"
              class="container todo-container"
              non-drag-area-selector=".drag-disabled"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('todoTasks', $event)"
            >
              <Draggable v-for="item in todoTasks" :key="item.id">
                <TaskCards
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                  :priority="item.priority === 'high' ? true : false"
                  :isLoadingList="isLoadingList"
                  :cardData="item"
                  :class="cardClass"
                  :list="todoTasks"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :statusTitle="listTwoTitle"
                  :trackerID="item.lastTracker.id"
                  :shouldPatch="shouldPatch"
                  v-on:updateQueue="reloadQueues"
                  @card-moved="onCardMoved"
                  :status="statusIdTwo"
                  :profileId="profileId"
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                @infinite="infiniteHandlerTodo"
                :identifier="todoInfiniteId"
                force-use-infinite-wrapper=".todo-container"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[todoTasks.length === 0 ? 'add-another-task-btn' : null]"
          >
            <h6
              v-if="role === 'assistant' && !searchMode"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdTwo, false)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pr-0 cards-container">
        <b-card
          class=" px-2 py-2"
          :class="{
            'task-cards-wrapper': laterTasks.length,
            'empty-task-cards-wrapper': !laterTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_later.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listThreeTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              v-if="!searchMode"
              :cardCount="laterTasks.length"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[2]"
              :board="BOARDS.EA"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              class="container later-container"
              non-drag-area-selector=".drag-disabled"
              :get-child-payload="getChildPayload3"
              group-name="1"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('laterTasks', $event)"
            >
              <Draggable v-for="item in laterTasks" :key="item.id">
                <TaskCards
                  :priority="item.priority === 'high' ? true : false"
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                  v-on:updateQueue="reloadQueues"
                  :isLoadingList="isLoadingList"
                  :class="cardClass"
                  @card-moved="onCardMoved"
                  :cardData="item"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :trackerID="item.lastTracker.id"
                  :list="laterTasks"
                  :statusTitle="listThreeTitle"
                  :shouldPatch="shouldPatch"
                  :status="statusIdThree"
                  :profileId="profileId"
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                @infinite="infiniteHandlerLater"
                :identifier="laterInfiniteId"
                force-use-infinite-wrapper=".later-container"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[laterTasks.length === 0 ? 'add-another-task-btn' : null]"
          >
            <h6
              v-if="role === 'assistant' && !searchMode"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdThree, false)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pr-0 cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': inProgressTasks.length,
            'empty-task-cards-wrapper': !inProgressTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_in_progress.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listFourTitle }}
            </h6>
            <bulk-actions-dropdown
              :statuses="statuses"
              v-if="!searchMode"
              :cardCount="inProgressTasks.length"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[3]"
              :board="BOARDS.EA"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              @touchend="fixDragAndDropMobile"
              :get-child-payload="getChildPayload4"
              non-drag-area-selector=".drag-disabled"
              drag-class="card-ghost"
              class="container inprogress-container"
              drop-class="card-ghost-drop"
              :drop-placeholder="dropPlaceholderOptions"
              group-name="1"
              @drop="onDrop('inProgressTasks', $event)"
            >
              <Draggable v-for="item in inProgressTasks" :key="item.id">
                <TaskCards
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                  :priority="item.priority === 'high' ? true : false"
                  :isLoadingList="isLoadingList"
                  :class="cardClass"
                  :cardData="item"
                  :statusTitle="listFourTitle"
                  v-on:updateQueue="reloadQueues"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  @card-moved="onCardMoved"
                  :list="inProgressTasks"
                  :shouldPatch="shouldPatch"
                  :status="statusIdFour"
                  :trackerID="item.lastTracker.id"
                  :profileId="profileId"
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                @infinite="infiniteHandlerInProgress"
                :identifier="inProgressInfiniteId"
                force-use-infinite-wrapper=".inprogress-container"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[
              inProgressTasks.length === 0 ? 'add-another-task-btn' : null
            ]"
          >
            <h6
              v-if="role === 'assistant' && !searchMode"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdFour, false)"
            >
              + Add another task
            </h6>
            
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="pr-0 cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': completedTasks.length,
            'empty-task-cards-wrapper': !completedTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center ">
            <img src="@/assets/icons/circle_complete.svg" alt="" />
            <h6
              class="font-sm primary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listFiveTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              v-if="!searchMode"
              :cardCount="completedTasks.length"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[4]"
              :board="BOARDS.EA"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              :get-child-payload="getChildPayload5"
              group-name="1"
              drag-class="card-ghost"
              non-drag-area-selector=".drag-disabled"
              drop-class="card-ghost-drop"
              class="container completed-container"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('completedTasks', $event)"
            >
              <Draggable v-for="item in completedTasks" :key="item.id">
                <TaskCards
                  :time="getMoment(item)"
                  :paused="true"
                  :isLoadingList="isLoadingList"
                  :class="cardClass"
                  :priority="item.priority === 'high' ? true : false"
                  :cardData="item"
                  :list="completedTasks"
                  :trackerID="item.lastTracker.id"
                  v-on:updateQueue="reloadQueues"
                  @card-moved="onCardMoved"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :shouldPatch="shouldPatch"
                  :status="statusIdFive"
                  :statusTitle="listFiveTitle"
                  :profileId="profileId"
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                @infinite="infiniteHandlerCompleted"
                :identifier="completedInfiniteId"
                force-use-infinite-wrapper=".completed-container"
              >
                <div slot="no-more">
                  <p class="mt-3 primary--text">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3 primary--text">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <!-- <div
            class="d-flex ml-3"
            :class="[
              completedTasks.length === 0 ? 'add-another-task-btn' : null
            ]"
          >
            <h6
              v-if="role === 'assistant' && !searchMode"
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdFive, false)"
            >
              + Add another task
            </h6>
          </div> -->
        </b-card>
      </b-col>
    </b-row>
    <!-- <div
      class="no-assigned-msg position-absolute d-flex flex-column justify-content-center align-items-center"
    >
      <h4 class="primary--text font-family-medium" v-if="showEmptyTasksMsg">
        No tasks created yet.
      </h4>
    </div> -->
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      v-model="showAuthError"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-container fluid>
        <b-button class="d-flex position-absolute close-btn">
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
      </b-container>
    </b-modal>
    <!-- End -->
    <b-avatar
      v-if="role === 'assistant'"
      button
      @click="navigate(statusIdTwo, false)"
      size="4.8rem"
      class="floating-action-btn btn-danger mb-5 position-fixed cursor-pointer"
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar>
    <view-task-modal
      v-model="viewTaskModal.visible"
      @task-deleted="onTaskDeleted"
      @task-archived="onTaskArchived"
      paBreadcrumb
      @task-handover="reloadAllQueues"
      @timer-started="reloadAllQueues"
      @timer-stopped="reloadAllQueues"
      @status-updated="reloadAllQueues"
      :taskId="viewTaskModal.taskId"
      @navigate="onNavigate"
    />
  </div>
</template>

<script>
import TaskCards from "@/components/taskcardsComponent/TaskCards.vue";
import { applyDrag } from "@/utils/applyDrag";
import { Container, Draggable } from "vue-smooth-dnd";
import { mapActions, mapState } from "vuex";
import {
  getAdminTaskBoard,
  getPATaskBoard,
  searchTasks,
  getTaskStatus,
  patchTaskBoard
} from "@/apis/common";
import ScrollPanner from "@/utils/ScrollPanner.js";
import ViewTaskModal from "@/views/common/ViewTaskModal"
import moment from "moment";
import BulkActionsDropdown from "@/components/dropdowns/BulkActionsDropdown.vue";
import { BOARDS } from '@/utils/constants'

export default {
  name: "TaskDashboard",
  components: {
    TaskCards,
    Draggable,
    ViewTaskModal,
    Container,
    BulkActionsDropdown
  },
  computed: {
    ...mapState("authModule", ["profileUserId"]),
    cardClass() {
      return this.searchMode ? 'drag-disabled': ''
    },
    showEmptyTasksMsg() {
      return (
        !this.isLoadingList &&
        this.todoTasks.length === 0 &&
        this.laterTasks.length === 0 &&
        this.inProgressTasks.length === 0 &&
        this.completedTasks.length === 0
      );
    }
  },
  mounted() {
    this.actionGetUserDetails()
      .then(res => {
        this.role = res.role;
        getTaskStatus().then(res => {
          this.statuses = res.data.results.sort(
            (a, b) => a.position - b.position
          );
          this.statusIdOne = this.statuses[0].id;
          this.statusIdTwo = this.statuses[1].id;
          this.statusIdThree = this.statuses[2].id;
          this.statusIdFour = this.statuses[3].id;
          this.statusIdFive = this.statuses[4].id;
          this.listOneTitle = this.statuses[0].title;
          this.listTwoTitle = this.statuses[1].title;
          this.listThreeTitle = this.statuses[2].title;
          this.listFourTitle = this.statuses[3].title;
          this.listFiveTitle = this.statuses[4].title;
          this.statusLoaded = true;
          this.$nextTick(() => {
            new ScrollPanner().initialize(this);
          });
        });
      })
      .catch(err => {
        console.log(err);
      });
  },
  data() {
    return {
      profileId: "",
      role: "",
      reloadingDaily: false,
      reloadingTodo: false,
      reloadingLater: false,
      reloadingInProgress: false,
      reloadingCompleted: false,
      viewTaskModal: {
        visible: false,
        taskId: null
      },
      listTitles: [],
      assistants: [],
      BOARDS,
      statusIds: [],
      listOneTitle: "",
      listTwoTitle: "",
      listThreeTitle: "",
      listFourTitle: "",
      listFiveTitle: "",
      showAuthError: false,
      statusIdOne: "",
      statusIdTwo: "",
      statusIdThree: "",
      statusIdFour: "",
      statusIdFive: "",
      offsetTodo: 0,
      offsetLater: 0,
      offsetDaily: 0,
      offsetInProgress: 0,
      offsetCompleted: 0,
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: false
      },
      limit: this.searchMode ? 20 : 20,
      unAssignedTasks: [],
      todoTasks: [],
      laterTasks: [],
      inProgressTasks: [],
      completedTasks: [],
      dailyTasks: [],
      shouldPatch: false,
      statuses: [],
      isLoadingList: true,
      count: null,
      todoInfiniteId: +new Date(),
      dailyInfiniteId: new Date() * 2,
      laterInfiniteId: new Date() * 3,
      inProgressInfiniteId: new Date() * 4,
      completedInfiniteId: new Date() * 5,
      statusLoaded: false
    };
  },
  props: {
    searchMode: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  methods: {
    dragListener() {
      // this dummy function is apparently necessary because without it the drag-start and
      // drag-end events don't fire
    },
    onNavigate() {
      this.viewTaskModal.visible = false
    },
    onTaskDeleted() {
      this.reloadAllQueues()
    },
    onTaskArchived() {
      this.reloadAllQueues();
    },
    onCardClick(card) {
      if (this.searchMode) {
        this.$router.push({
          name: "ViewTask",
          params: {
            id: card.cardData.id
          }
        })
      } else {
        this.viewTaskModal.taskId = card.cardData.id
        this.viewTaskModal.visible = true
      }
    },
    onCardDoubleClick(card) {
      this.$router.push({
        name: "ViewPATask",
        params: {
          id: card.cardData.id
        }
      })
    },
    onBulkAction() {
      this.reloadAllQueues()
    },
    async onCardMoved(card) {
      let payload = {
        status: card.status,
        completedDate:
          card.statusTitle === "Complete"
            ? moment()
                .utc()
                .format("YYYY-MM-DD")
            : null
      };
      let cardId = card.cardData.id;
      try {
        let res = await patchTaskBoard(cardId, payload);
        const statusIds = [
          this.statusIdOne,
          this.statusIdTwo,
          this.statusIdThree,
          this.statusIdFour,
          this.statusIdFive,
        ]
        let toIndex = statusIds.findIndex(
          status => res.data.status.id === status
        );
        let fromIndex = statusIds.findIndex(
          status => card.cardData.status.id === status
        );
        // keep the reactive properites in sync with the API data
        let cardInfoObject = card.list.find(card => card.id === cardId);
        cardInfoObject.status = res.data.status;
        cardInfoObject.position = res.data.position;
        // reload the queues
        if (res.data.isPositionReset) {
          this.reloadAllQueues();
        } else {
          this.reloadQueues(fromIndex, toIndex, true);
        }
      } catch (e) {
        console.log(e);
        // e.g. the completed-task lock window has closed - the card already
        // moved visually via onDrop, so reload to snap it back to the real
        // server state. Same toast treatment as the 2-running-timers cap.
        this.$bvToast.toast(
          e.response?.data?.detail || "Unable to move this task.",
          {
            title: "⚠ Task",
            variant: "danger",
            solid: true,
            autoHideDelay: 8000,
            toaster: "b-toaster-top-center",
            toastClass: "hr-toast-alert"
          }
        );
        this.reloadAllQueues();
      }
    },
    reloadQueues(fromIndex, toIndex, updateSource) {
      let reloadArray = [
        this.reloadDaily,
        this.reloadTodo,
        this.reloadLater,
        this.reloadInProgress,
        this.reloadCompleted
      ];
      let taskArrays = [
        this.dailyTasks,
        this.todoTasks,
        this.laterTasks,
        this.inProgressTasks,
        this.completedTasks
      ];
      if (taskArrays[fromIndex].length < 3 && updateSource) {
        reloadArray[fromIndex]();
      }
      reloadArray[toIndex]();
    },
    reloadAllQueues() {
      this.dailyTasks = [];
      this.todoTasks = [];
      this.laterTasks = [];
      this.inProgressTasks = [];
      this.completedTasks = [];

      this.reloadDaily();
      this.reloadTodo();
      this.reloadLater();
      this.reloadInProgress();
      this.reloadCompleted();
    },
    generateId(index) {
      return (
        "_" +
        Math.random()
          .toString(36)
          .substr(2, 9) +
        index
      );
    },
    reloadDaily() {
      this.offsetDaily = 0;
      this.reloadingDaily = true;
      this.dailyInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadTodo() {
      this.offsetTodo = 0;
      this.reloadingTodo = true;
      this.todoInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadLater() {
      this.offsetLater = 0;
      this.reloadingLater = true;
      this.laterInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadInProgress() {
      this.offsetInProgress = 0;
      this.reloadingInProgress = true;
      this.inProgressInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadCompleted() {
      this.offsetCompleted = 0;
      this.reloadingCompleted = true;
      this.completedInfiniteId += 1;
      this.shouldPatch = false;
    },
    infiniteHandlerDaily($state) {
      let getDailyBoard = null;
      if (this.role === "assistant") {
        getDailyBoard = getPATaskBoard;
      } else {
        getDailyBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[0].id,
        limit: this.limit,
        offset: this.offsetDaily,
        is_archive: false,
        created_gte: null,
        created_lte: null
      }
      let args = [this.$route.params.uuid, params]
      if (this.searchMode) {
        params = {
          status: this.statuses[0].id,
          assigned_to: this.profileUserId,
          limit: this.limit,
          search: this.$route.query.q,
          offset: this.offsetDaily,
        }
        getDailyBoard = searchTasks
        args = [params]
      }
      getDailyBoard.apply(null, args)
        .then(res => {
          if (this.reloadingDaily) {
            this.dailyTasks = [...res.data.results];
            this.reloadingDaily = false;
          } else {
            this.dailyTasks = [...this.dailyTasks, ...res.data.results];
          }
          this.offsetDaily = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerTodo($state) {
      let getTodoBoard = null;
      if (this.role === "assistant") {
        getTodoBoard = getPATaskBoard;
      } else {
        getTodoBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[1].id,
        limit: this.limit,
        is_archive: false,
        offset: this.offsetTodo,
        created_gte: null,
        created_lte: null
      }
      let args = [this.$route.params.uuid, params]
      if (this.searchMode) {
        params = {
          status: this.statuses[1].id,
          limit: this.limit,
          assigned_to: this.profileUserId,
          search: this.$route.query.q,
          offset: this.offsetTodo,
        }
        getTodoBoard = searchTasks
        args = [params]
      }
      getTodoBoard.apply(null, args)
        .then(res => {
          if (this.reloadingTodo) {
            this.todoTasks = [...res.data.results];
            this.reloadingTodo = false;
          } else {
            this.todoTasks = [...this.todoTasks, ...res.data.results];
          }
          this.offsetTodo = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerLater($state) {
      let getLaterBoard = null;
      if (this.role === "assistant") {
        getLaterBoard = getPATaskBoard;
      } else {
        getLaterBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[2].id,
        limit: this.limit,
        offset: this.offsetLater,
        is_archive: false,
        created_gte: null,
        created_lte: null
      }
      let args = [this.$route.params.uuid, params]
      if (this.searchMode) {
        params = {
          status: this.statuses[2].id,
          limit: this.limit,
          assigned_to: this.profileUserId,
          search: this.$route.query.q,
          offset: this.offsetLater,
        }
        args = [params]
        getLaterBoard = searchTasks
      }
      getLaterBoard.apply(null, args)
        .then(res => {
          if (this.reloadingLater) {
            this.laterTasks = [...res.data.results];
            this.reloadingLater = false;
          } else {
            this.laterTasks = [...this.laterTasks, ...res.data.results];
          }
          this.offsetLater = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerInProgress($state) {
      let getInProgressBoard = null;
      if (this.role === "assistant") {
        getInProgressBoard = getPATaskBoard;
      } else {
        getInProgressBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[3].id,
        limit: this.limit,
        offset: this.offsetInProgress,
        is_archive: false,
        created_gte: null,
        created_lte: null
      }
      let args = [this.$route.params.uuid, params]
      if (this.searchMode) {
        params = {
          status: this.statuses[3].id,
          limit: this.limit,
          assigned_to: this.profileUserId,
          search: this.$route.query.q,
          offset: this.offsetInProgress,
        }
        args = [params]
        getInProgressBoard = searchTasks
      }
      getInProgressBoard.apply(null, args)
        .then(res => {
          if (this.reloadingInProgress) {
            this.inProgressTasks = [...res.data.results];
            this.reloadingInProgress = false;
          } else {
            this.inProgressTasks = [
              ...this.inProgressTasks,
              ...res.data.results
            ];
          }
          this.offsetInProgress = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerCompleted($state) {
      let getCompletedBoard = null;
      if (this.role === "assistant") {
        getCompletedBoard = getPATaskBoard;
      } else {
        getCompletedBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[4].id,
        limit: this.limit,
        offset: this.offsetCompleted,
        is_archive: false,
        created_gte: null,
        created_lte: null
      }
      let args = [this.$route.params.uuid, params]
      if (this.searchMode) {
        params = {
          status: this.statuses[4].id,
          limit: this.limit,
          assigned_to: this.profileUserId,
          search: this.$route.query.q,
          offset: this.offsetCompleted,
        }
        args = [params]
        getCompletedBoard = searchTasks
      }
      getCompletedBoard.apply(null, args)
        .then(res => {
          if (this.reloadingCompleted) {
            this.completedTasks = [...res.data.results];
            this.reloadingCompleted = false;
          } else {
            this.completedTasks = [...this.completedTasks, ...res.data.results];
          }
          this.offsetCompleted = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    ...mapActions("authModule", ["actionGetUserDetails"]),
    navigate(id, frequency) {
      this.$router.push({
        name: "AddPATask",
        params: {
          uuid: this.$route.params.uuid,
          statusID: id,
          frequency: frequency
        }
      });
    },

    fixDragAndDropMobile() {
      document.body.classList.remove(
        "smooth-dnd-no-user-select",
        "smooth-dnd-disable-touch-action"
      );
    },
    onDrop(collection, dropResult) {
      this.shouldPatch = true;
      this[collection] = applyDrag(this[collection], dropResult);
    },
    getChildPayload1(index) {
      return this.dailyTasks[index];
    },
    getChildPayload2(index) {
      return this.todoTasks[index];
    },
    getChildPayload3(index) {
      return this.laterTasks[index];
    },
    getChildPayload4(index) {
      return this.inProgressTasks[index];
    },
    getChildPayload5(index) {
      return this.completedTasks[index];
    },
    getMoment: item => {
      if (item.lastTracker.startAt === null) {
        return 0;
      } else if (item.lastTracker.stopAt === null) {
        let duration = moment()
          .utc()
          .diff(item.lastTracker.startAt, "seconds");
        duration += item.trackersLog.timeSpent;
        return duration;
      } else {
        let duration = item.trackersLog.timeSpent;
        return duration;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.main-content-container {
  display: flex;
  flex-direction: column;
}
.task-cards-wrapper {
  height: 90%;
}
.skeleton-icons-group {
  right: -1rem;
}
.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
.no-assigned-msg {
  width: 95%;
  top: 75%;
}
.cards-container {
  height: 100%;
}
.container {
  padding: 0rem;
}
.empty-container {
  height: auto;
}
.tabs {
  height: 90%;
}
.task-dashboard-row {
  padding-bottom: 10px;
}
div.card.task-cards-wrapper {
  max-height: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  > div:nth-child(1) {
    // status title: Today, Later, etc
    flex: 0 0 auto;
  }
  > div:nth-child(2) {
    // scrollable container for cards
    flex: 1 1 auto;
    display: flex;
    min-height: 0;
  }
  > div:nth-child(3) {
    // + Add another task
    height: 10%;
  }
}
.task-dashboard-row {
  // height: 80%;
  padding-bottom: 10px;
}
.add-another-task {
  margin-top: 0rem !important;
  margin-bottom: 0rem;
}
</style>
